var _path, _rect, _path2, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMonivalintaIkoni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 79,
    viewBox: "0 0 98 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0553 22H38.1949L43.5759 7.34545H45.4077L50.7886 22H48.9282L44.549 9.66385H44.4345L40.0553 22ZM40.7423 16.2756H48.2413V17.8498H40.7423V16.2756Z",
    fill: "#444444"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 8.54004,
    width: 12,
    height: 12,
    rx: 6,
    fill: "white",
    stroke: "#767676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4686 71.8901V57.1174H44.6333C45.6623 57.1174 46.5111 57.2953 47.1795 57.6512C47.848 58.0022 48.3457 58.4759 48.6727 59.0722C48.9997 59.6637 49.1632 60.3201 49.1632 61.0414C49.1632 61.6762 49.0502 62.2003 48.8242 62.6139C48.6029 63.0275 48.3096 63.3545 47.9441 63.5949C47.5835 63.8353 47.1916 64.0133 46.7684 64.1287V64.2729C47.2204 64.3018 47.6748 64.4605 48.1317 64.749C48.5885 65.0376 48.9708 65.4511 49.2786 65.9897C49.5864 66.5283 49.7402 67.1871 49.7402 67.9661C49.7402 68.7067 49.5719 69.3727 49.2353 69.9642C48.8987 70.5557 48.3673 71.0245 47.6412 71.3708C46.915 71.717 45.9701 71.8901 44.8064 71.8901H39.4686ZM41.2575 70.3032H44.8064C45.9749 70.3032 46.8044 70.0772 47.2949 69.6252C47.7903 69.1683 48.0379 68.6153 48.0379 67.9661C48.0379 67.466 47.9105 67.0044 47.6556 66.5812C47.4007 66.1532 47.0377 65.8118 46.5664 65.5569C46.0951 65.2972 45.5373 65.1674 44.8929 65.1674H41.2575V70.3032ZM41.2575 63.6093H44.5756C45.1141 63.6093 45.5998 63.5035 46.0326 63.2919C46.4702 63.0804 46.8165 62.7822 47.0713 62.3975C47.331 62.0128 47.4608 61.5608 47.4608 61.0414C47.4608 60.3922 47.2348 59.8416 46.7828 59.3896C46.3308 58.9327 45.6143 58.7043 44.6333 58.7043H41.2575V63.6093Z",
    fill: "#444444"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 58.4302,
    width: 12,
    height: 12,
    rx: 6,
    fill: "white",
    stroke: "#767676"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonivalintaIkoni);
export default __webpack_public_path__ + "static/media/Monivalinta_ikoni.6f3959586bde7c7f83ac1e95aec0fadd.svg";
export { ForwardRef as ReactComponent };